module.exports = __webpack_public_path__ + "img/lingbolive_name@3x.dd00895d.png";